export default __webpack_public_path__ + "static/media/sv&j-logo.2226d54d.png";